(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[531],{

/***/ 3789:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/issues/[number]",
      function () {
        return __webpack_require__(9403);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6351);
/* harmony import */ var _components_Issue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9418);
/* harmony import */ var _components_LocationInfo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5119);




var description = "Volume 7 da Revista Aufkl\xe4rung, n\xfamero ".concat('especial' || 0, ".");
var title = 'Dossi\xea Sartre' || 0;
var Issue = function() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                description: description,
                openGraph: {
                    description: description,
                    title: title
                },
                title: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LocationInfo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: "v. 7 n. Especial (2020): Dossi\xea Sartre"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Issue__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Issue);


/***/ }),

/***/ 9418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Issue; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.0.10_react-dom@17.0.2+react@17.0.2/node_modules/next/router.js
var router = __webpack_require__(1999);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-icons@4.3.1_react@17.0.2/node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(999);
// EXTERNAL MODULE: ./src/ui/components/custom/Link/index.tsx
var Link = __webpack_require__(5879);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_281a4fa50a045c9112baf635f3bc27a7/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9306);
;// CONCATENATED MODULE: ./src/ui/components/Issue/styles.ts

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n > span {\n  display: block;\n  font-size: 0.9em;\n  font-weight: 700;\n  margin: 2vh 2vw;\n\n  @media (max-width: 426px) {\n   margin: 2vh 4vw;\n  }\n }\n\n > strong {\n  display: block;\n  margin: 1vh 2vw;\n\n  font-size: 1.4em;\n  font-weight: 600;\n  font-variant: small-caps;\n  color: #0007;\n\n  @media (max-width: 426px) {\n   margin-left: 4vw;\n  }\n }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n display: flex;\n flex-direction: column;\n align-items: center;\n\n padding: 0 2vw;\n border-bottom: 1px solid #ddd;\n\n @media (max-width: 426px) {\n  padding: 0 4vw;\n }\n\n img {\n  max-height: 85vh;\n  max-width: 100%;\n }\n\n > * {\n  margin-bottom: 2vh;\n }\n\n span {\n  strong {\n   color: #777;\n  }\n }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n display: flex;\n flex-direction: column;\n padding: 0 2vw 3vh;\n\n &:first-of-type {\n  border-bottom: 1px solid #ddd;\n }\n\n @media (max-width: 426px) {\n  padding: 0 4vw 3vh;\n }\n\n > p {\n  font-variant: small-caps;\n  font-weight: 600;\n  font-size: 1.4em;\n\n  a {\n   color: #f70;\n\n   &:hover {\n    color: #479;\n   }\n  }\n }\n\n div {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.9em;\n  margin: 0.5vh 0 1.5vh;\n\n  span {\n   color: #0007;\n\n   @media (max-width: 426px) {\n    max-width: 20%;\n   }\n  }\n }\n\n button {\n  color: #fff;\n  background: #479;\n  padding: 1vh 1vw;\n  margin-right: auto;\n  border-radius: 4px;\n\n  @media (max-width: 426px) {\n   padding: 2vh 4vw;\n   margin: auto;\n  }\n\n  svg {\n   margin-right: 0.5vw;\n   transform: translate(0, 10%);\n  }\n\n  &:hover {\n   background: #f70;\n  }\n }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var Container = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    componentId: "sc-ef386f9b-0"
})(_templateObject());
var Introduction = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef386f9b-1"
})(_templateObject1());
var Section = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-ef386f9b-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/ui/components/Issue/index.tsx





var Issue = function() {
    var pathname = (0,router.useRouter)().pathname;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            pathname === '/' && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "v. 7 n. Especial (2020): Dossi\xea Sartre"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Introduction, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/issues/19",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/tmp/cover-19.png",
                            alt: "Capa da edi\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Dossi\xea Sartre"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Publicado: "
                            }),
                            "2020-02-19"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: "Editorial"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "/issues/19/articles/1",
                            children: "Apresenta\xe7\xe3o"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Claudinei Aparecido de Freitas da Silva"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "p.7-10"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaRegFilePdf */.B$y, {}),
                            "PDF"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: "Artigos"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "/issues/19/articles/2",
                            children: "Revolu\xe7\xe3o est\xe9tica - a livre inven\xe7\xe3o de espa\xe7os de liberdade"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Luciano Donizetti da Silva"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "p.11-24"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaRegFilePdf */.B$y, {}),
                            "PDF"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "/issues/19/articles/3",
                            children: "Filosofia e literatura: em torno de A N\xe1usea"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Luiza Helena Hilgert"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "p.25-38"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaRegFilePdf */.B$y, {}),
                            "PDF"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "/issues/19/articles/4",
                            children: "Les Mouches: liberdade situada e reflexividades em Jean-Paul Sartre"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Marivania Cristina Bocca, Tiago Soares dos Santos"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "p.39-50"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaRegFilePdf */.B$y, {}),
                            "PDF"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "/issues/19/articles/5",
                            children: "A experi\xeancia do non-sens em Roquentin: A N\xe1usea sob as lentes da psican\xe1lise"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Renato Santos"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "p.51-64"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaRegFilePdf */.B$y, {}),
                            "PDF"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "/issues/19/articles/6",
                            children: "O car\xe1ter nadificador da consci\xeancia imaginante"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Lucas Rodrigues da Fonseca Lopes"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "p.65-76"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaRegFilePdf */.B$y, {}),
                            "PDF"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "/issues/19/articles/7",
                            children: "A Fenomenologia de Heidegger e Sartre em suas diferen\xe7as"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Daniela Ribeiro Schneider"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "p.77-92"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaRegFilePdf */.B$y, {}),
                            "PDF"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "/issues/19/articles/8",
                            children: "Literatura e Humanismo: Fen\xf4menos \xe9ticos no confronto entre Sartre e Dostoi\xe9vski"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Cristiane Picinini"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "p.93-102"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaRegFilePdf */.B$y, {}),
                            "PDF"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "/issues/19/articles/9",
                            children: "O fen\xf4meno da ang\xfastia: interfaces entre Graciliano Ramos e Sartre"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Camila Pacheco Gomes"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "p.103-114"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaRegFilePdf */.B$y, {}),
                            "PDF"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "/issues/19/articles/10",
                            children: "A est\xe9tica do movimento: uma leitura sartriana da psicoterapia a partir da arte de Alberto Giacometti"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Georges Daniel Janja Bloc Boris, Daniel Marcio Pereira Melo"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "p.115-126"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaRegFilePdf */.B$y, {}),
                            "PDF"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "/issues/19/articles/11",
                            children: "El existencialismo de Sartre, or\xedgenes y contextos: una lectura a partir de Hannah Arendt"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Gerardo Miguel Nieves-Loja"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "p.127-136"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaRegFilePdf */.B$y, {}),
                            "PDF"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "/issues/19/articles/12",
                            children: "Aportes cl\xednicos sartrianos III: m\xe9todo progressivo-regressivo"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Claudinei Aparecido de Freitas da Silva"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "p.137-150"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaRegFilePdf */.B$y, {}),
                            "PDF"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "/issues/19/articles/13",
                            children: "O tempo em Heidegger e Thomas Mann"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Libanio Cardoso"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "p.153-168"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaRegFilePdf */.B$y, {}),
                            "PDF"
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var components_Issue = (Issue);


/***/ }),

/***/ 5119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LocationInfo; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.0.10_react-dom@17.0.2+react@17.0.2/node_modules/next/router.js
var router = __webpack_require__(1999);
// EXTERNAL MODULE: ./src/ui/components/custom/Link/index.tsx
var Link = __webpack_require__(5879);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_281a4fa50a045c9112baf635f3bc27a7/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9306);
;// CONCATENATED MODULE: ./src/ui/components/LocationInfo/styles.ts

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n font-size: 0.9em;\n margin: 2vh 2vw;\n\n @media (max-width: 462px) {\n  margin: 2vh 4vw;\n }\n\n span:last-of-type {\n  color: #f70;\n }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba06a0ec-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/ui/components/LocationInfo/index.tsx




var LocationInfo = function(param) {
    var children = param.children;
    var pathname = (0,router.useRouter)().pathname;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                href: "/",
                children: "In\xedcio"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: " / "
            }),
            pathname.match(/\/issues.+/) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: "/issues",
                    children: "Arquivos / "
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children
            })
        ]
    }));
};
/* harmony default export */ var components_LocationInfo = (LocationInfo);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [522,888,179], function() { return __webpack_exec__(3789); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);